// Shared locale broadcast for the single-spa host + micro-frontends.
//
// Each shell (host web-app and every MFE) runs its OWN i18next instance with
// MFE-scoped namespaces — a single global i18next singleton would let one
// MFE's keys clobber another's. To keep them in sync we broadcast the active
// locale over a same-origin window event: whoever changes the language emits,
// and every instance subscribes and calls its own loadLocale/changeLanguage.
//
// Same-tab CustomEvent (not the `storage` event, which only fires cross-tab),
// so a switch in the host nav updates the mounted MFE live, without a reload.

const LOCALE_EVENT = 'mb:i18n-locale';

export function emitLocaleChange(locale: string): void {
	if (typeof window === 'undefined') return;
	window.dispatchEvent(new CustomEvent(LOCALE_EVENT, { detail: locale }));
}

export function subscribeLocaleChange(
	handler: (locale: string) => void,
): () => void {
	if (typeof window === 'undefined') return () => {};
	const listener = (event: Event) => {
		const locale = (event as CustomEvent<string>).detail;
		if (typeof locale === 'string' && locale) handler(locale);
	};
	window.addEventListener(LOCALE_EVENT, listener);
	return () => window.removeEventListener(LOCALE_EVENT, listener);
}
